export default "__VITE_ASSET__c5d3f9b8__"